const SITE_URL = 'https://toastie.au';

export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Toastie Health',
  url: SITE_URL,
  logo: `${SITE_URL}/assets/toastie-logo.png`,
  sameAs: [
    'https://tiktok.com/@toastiehealth',
    'https://instagram.com/toastiehealth',
    'https://www.linkedin.com/company/toastie',
    'https://www.youtube.com/@toastiehealth',
    'https://www.reddit.com/r/ToastieHealth/',
  ],
  founder: [
    {
      '@type': 'Person',
      name: 'Annabel Zhou',
      sameAs: 'https://www.linkedin.com/in/annabelzh/',
    },
    {
      '@type': 'Person',
      name: 'Viv Shen',
      sameAs: 'https://www.linkedin.com/in/vivshen/',
    },
  ],
  award: [
    'Startup Woman of the Year Award - OneRoof',
    'UNSW Founders New Wave 3x Award Winner',
  ],
};

export const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Toastie Health',
  url: SITE_URL,
};

export const softwareApplicationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'MobileApplication',
  name: 'Toastie Health',
  applicationCategory: 'HealthApplication',
  operatingSystem: 'iOS, Android',
  description:
    'AI-powered chronic illness tracker for symptoms, medications, meals, and mood, with lab report digitisation and AI-generated doctor summary reports.',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
  },
};

export function itemListJsonLd(items: { name: string; path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      url: `${SITE_URL}${item.path}`,
    })),
  };
}

export function articleJsonLd(article: {
  title: string;
  description: string;
  path: string;
  datePublished: string;
  image?: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    url: `${SITE_URL}${article.path}`,
    datePublished: article.datePublished,
    image: article.image ?? `${SITE_URL}/assets/toastie-logo.png`,
    author: { '@type': 'Organization', name: 'Toastie Health', url: SITE_URL },
    publisher: {
      '@type': 'Organization',
      name: 'Toastie Health',
      logo: { '@type': 'ImageObject', url: `${SITE_URL}/assets/toastie-logo.png` },
    },
    about: { '@type': 'MobileApplication', name: 'Toastie Health' },
  };
}

export function breadcrumbJsonLd(items: { name: string; path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}
